<template>
	<div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="
				() => {
					showForm = !showForm
					generateInventoryReport(false)
				}
			"
			:title-form="$t('relatorioInventarioFlorestal')"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; gap: 1rem; flex-direction: column">
					<DropdownFk
						v-model="fazendaEscolhida"
						:dropdown-options="fazendas"
						:label="$t('pickFarm')"
					/>
					<!-- <DropdownFk :dropdownOptions="processamentos" v-model="processamentoEscolhido"
                        :label="$t('escolhaProcessamento')" /> -->

					<DropdownCheckboxFk
						:empty-label="$t('')"
						:label="$t('escolhaProcessamento')"
						:dropdown-options="processamentos"
						:ignore-properties="['id']"
						:value="processamentosSelecionados"
					/>

					<div v-if="baixandoRelatorio">
						<Loading />
						<p style="text-align: center">
							{{ $t('baixandoRelatorio') }}
						</p>
					</div>
					<Button
						v-else
						:disabled="!escolheuFazendaEProcessamento"
						:label="$t('download')"
						@click="generateReport"
					/>
					<!-- 
                    <Button  @click="generateReportBetas" :disabled="!escolheuFazendaEProcessamento"
                       :label="$t('exportBetas')" /> -->
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button.vue'
import CrudForm from '../../../components/CrudForm/CrudForm.vue'
import DropdownFk from '../../../components/DropdownFk/DropdownFk.vue'
import Loading from '../../../components/Loading/Loading.vue'
import DropdownCheckboxFk from '../../../components/DropdownCheckboxFk/DropdownCheckboxFk'

import {
	getAllEstrato,
	gerarRelatorioInventarioFlorestalLegacy,
	gerarRelatorioBetasLegacy,
} from '../../../services/requests/RelatorioRequests'

import _ from 'lodash'
import { mapMutations } from 'vuex'

export default {
	name: 'RelatorioInventarioFlorestalLegacy',
	components: {
		Button,
		CrudForm,
		DropdownFk,
		DropdownCheckboxFk,
		Loading,
	},
	data() {
		return {
			dropdown: [],
			fazendaEscolhida: '',
			fetchingData: false,
			processamentoEscolhido: '',
			processamentosSelecionados: [],
			showForm: true,
			baixandoRelatorio: false,
		}
	},
	computed: {
		escolheuFazendaEProcessamento() {
			return this.fazendaEscolhida != '' && this.processamentosSelecionados != ''
		},
		fazendas() {
			return _.uniqBy(
				this.dropdown.map((processamento) => {
					return {
						[this.$t('name')]: processamento.fazenda.nome,
						[this.$t('code')]: processamento.fazenda.codigo,
						id: processamento.fazenda.id,
					}
				}),
				'id',
			)
		},
		processamentos() {
			return this.dropdown
				.filter((processamento) => processamento.fazenda.id === this.fazendaEscolhida)
				.map((proc) => {
					return {
						[this.$t('name')]: proc.descricao,
						[this.$t('code')]: proc.codigo,
						id: proc.id,
					}
				})
		},
	},
	destroyed() {
		this.generateInventoryReport(false)
	},
	created() {
		getAllEstrato().then((response) => {
			this.dropdown = response.data.result.result
		})
	},
	methods: {
		...mapMutations('moduleReports', ['generateInventoryReport', 'generateServiceOrderReport']),

		generateReport() {
			this.baixandoRelatorio = true

			let processamentosParaExportar = this.processamentosSelecionados
				.filter((processamento) => processamento)
				.map((processamento) => {
					return {
						EstratoInventarioFlorestalId: processamento,
					}
				})

			let requisicaoParaExportar = {
				tipoExportacao: 'Default',
				processamento: processamentosParaExportar,
			}

			gerarRelatorioInventarioFlorestalLegacy(requisicaoParaExportar)
				.then((result) => {
					if (result.data.result == null) {
						this.downloadRelatorio(result.data.message)
					} else {
						var linksRelatorios = result.data.result
						linksRelatorios.forEach((linkRelatorio) => {
							this.downloadRelatorio(linkRelatorio)
						})
					}
					this.baixandoRelatorio = false
				})
				.catch((error) => {
					alert('Problema ao baixar o relatório, entre em contato com o suporte')
					this.baixandoRelatorio = false
					console.log(error)
				})
		},

		downloadRelatorio(link) {
			window.open(link, '_blank')
		},

		generateReportBetas() {
			this.baixandoRelatorio = true
			gerarRelatorioBetasLegacy(this.processamentosSelecionados)
				.then((result) => {
					var linkRelatorio = result.data.message
					this.downloadRelatorio(linkRelatorio)
					this.baixandoRelatorio = false
				})
				.catch((error) => {
					alert('Problema ao baixar o relatório dos betas, entre em contato com o suporte')
					this.baixandoRelatorio = false
					console.log(error)
				})
		},
	},
}
</script>
<style></style>
